const doc = {
  state: {
    docRevsList: null,
    documentRevsList: null,
    documentRevMod: null,
    documentLog: null,
    logDID: null,
    documentLogUserUnreadCounter: null,
    documentLogUserAttentionCounter: null,
    documentLogCompanyUnreadCounter: null,
    documentLogCompanyAttentionCounter: null,
    documentLogFacilityUnreadCounter: null,
    documentLogFacilityAttentionCounter: null,
    documentLogTag: null
  },
  mutations: {
    changeLogDID(state, payload) {
      state.logDID = payload;
    },
    changeDocRevsList(state, payload) {
      state.docRevsList = payload;
    },
    changeDocumentRevsList(state, payload) {
      state.documentRevsList = payload;
    },
    changeDocumentRevMod(state, payload) {
      state.documentRevMod = payload;
    },
    changeDocumentLog(state, payload) {
      state.documentLog = payload;
    },
    changeDocumentLogUserUnreadCounter(state, payload) {
      state.documentLogUserUnreadCounter = payload;
    },
    changeDocumentLogUserAttentionCounter(state, payload) {
      state.documentLogUserAttentionCounter = payload;
    },
    changeDocumentLogCompanyUnreadCounter(state, payload) {
      state.documentLogCompanyUnreadCounter = payload;
    },
    changeDocumentLogCompanyAttentionCounter(state, payload) {
      state.documentLogCompanyAttentionCounter = payload;
    },
    changeDocumentLogFacilityUnreadCounter(state, payload) {
      state.documentLogFacilityUnreadCounter = payload;
    },
    changeDocumentLogFacilityAttentionCounter(state, payload) {
      state.documentLogFacilityAttentionCounter = payload;
    },
    changeDocumentLogTag(state, payload) {
      state.documentLogTag = payload;
    }
  },
  actions: {
    changeLogDID({ commit }, payload) {
      commit("changeLogDID", payload);
    },
    changeDocRevsList({ commit }, payload) {
      commit("changeDocRevsList", payload);
    },
    changeDocumentRevsList({ commit }, payload) {
      commit("changeDocumentRevsList", payload);
    },
    changeDocumentRevMod({ commit }, payload) {
      commit("changeDocumentRevMod", payload);
    },
    changeDocumentLog({ commit }, payload) {
      commit("changeDocumentLog", payload);
    },
    changeDocumentLogUserUnreadCounter({ commit }, payload) {
      commit("changeDocumentLogUserUnreadCounter", payload);
    },
    changeDocumentLogUserAttentionCounter({ commit }, payload) {
      commit("changeDocumentLogUserAttentionCounter", payload);
    },
    changeDocumentLogCompanyUnreadCounter({ commit }, payload) {
      commit("changeDocumentLogCompanyUnreadCounter", payload);
    },
    changeDocumentLogCompanyAttentionCounter({ commit }, payload) {
      commit("changeDocumentLogCompanyAttentionCounter", payload);
    },
    changeDocumentLogFacilityUnreadCounter({ commit }, payload) {
      commit("changeDocumentLogFacilityUnreadCounter", payload);
    },
    changeDocumentLogFacilityAttentionCounter({ commit }, payload) {
      commit("changeDocumentLogFacilityAttentionCounter", payload);
    },
    changeDocumentLogTag({ commit }, payload) {
      commit("changeDocumentLogTag", payload);
    }
  },
  getters: {
    getLogDID: state => {
      return state.logDID;
    },
    getDocRevsList: state => {
      return state.docRevsList;
    },
    getDocumentRevsList: state => {
      return state.documentRevsList;
    },
    getDocumentRevMod: state => {
      return state.documentRevMod;
    },
    getDocumentLog: state => {
      return state.documentLog;
    },
    getDocumentLogUserUnreadCounter: state => {
      return state.documentLogUserUnreadCounter;
    },
    getDocumentLogUserAttentionCounter: state => {
      return state.documentLogUserAttentionCounter;
    },
    getDocumentLogCompanyUnreadCounter: state => {
      return state.documentLogCompanyUnreadCounter;
    },
    getDocumentLogCompanyAttentionCounter: state => {
      return state.documentLogCompanyAttentionCounter;
    },
    getDocumentLogFacilityUnreadCounter: state => {
      return state.documentLogFacilityUnreadCounter;
    },
    getDocumentLogFacilityAttentionCounter: state => {
      return state.documentLogFacilityAttentionCounter;
    },
    getDocumentLogTag: state => {
      return state.documentLogTag;
    }
  }
  // eslint-disable-next-line
}
// eslint-disable-next-line
export default doc;
